import { CacheOptions } from '@/types/Hooks/cache';

export const useFilterSubsidiariesByRegion = () => {
  return (subsidiaries: CacheOptions[], regionsIds: string[]) =>
    subsidiaries.filter(subsidiary => subsidiary.region_id && regionsIds.includes(subsidiary.region_id));
};
